var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selection-title"},[_vm._v(" "+_vm._s(_vm.title)+". (Render Total Time:"),_c('span',{staticClass:"total-time"},[_vm._v(" "+_vm._s(_vm.rederTime)+" ms")]),_vm._v(") ")])}
var staticRenderFns = []

export { render, staticRenderFns }